import React from 'react'
import { AppHOC, AppProps } from './AppHOC'

const OverviewContainer = React.lazy(() => import('@components/Overview'))

export const OverviewApp: React.FC<AppProps> = props => {
  const { session, actionModule, environment, widgetContext } = props
  return (
    <AppHOC session={session} environment={environment} actionModule={actionModule} widgetContext={widgetContext}>
      <OverviewContainer />
    </AppHOC>
  )
}
